import DashboardLink from '@/components/dashboard/dashboard-link/dashboard-link';
import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import MainContent from '@/components/main-layout/components/main-content/main-content';
import { ROUTE_ACCOUNT } from '@/constants/routes';
import { FormControl } from '@chakra-ui/react';
import { Box, Checkbox, Flex, Text } from '@cmpsr/components';
import AccountPanel from '../common/account-panel';
import SaveButton from '../common/save-button';
import useEditCommPreferencesPageController from './edit-comm-preferences.controller';

export default function EditCommPreferencesPage() {
  const { form, commPreferences, handleSaveCommPreferences } = useEditCommPreferencesPageController();

  return (
    <>
      <DashboardNavigationBar />
      <MainContent>
        <DashboardLink href={ROUTE_ACCOUNT}>Account</DashboardLink>
        <Box
          py={{ base: 'spacer-4', md: 'spacer-8', lg: 'spacer-12' }}
          px={{
            base: 'spacer-5',
            md: 'spacer-8',
            lg: 'spacer-44',
            xl: 'spacer-60',
            xxl: 'spacer-80',
          }}
          maxWidth="1440px"
          marginX="auto"
        >
          <AccountPanel header="Communication Preferences">
            <Text variant="text-body-regular" color="text-secondary" mb="spacer-5">
              I would like to receive communications via email from the following notifications:
            </Text>
            <form onSubmit={handleSaveCommPreferences}>
              <FormControl id="communication-preferences">
                {commPreferences.map((preference, index) => (
                  <Flex key={index} direction="column">
                    <Checkbox
                      defaultChecked={preference.enabled}
                      {...form.register(`preferences.${index}.enabled`)}
                      aria-label="Communication Preferences"
                      size="m"
                      mb="spacer-2"
                    >
                      {preference.title}
                    </Checkbox>
                  </Flex>
                ))}
                <SaveButton isLoading={form.formState.isSubmitting} mt="spacer-5" />
              </FormControl>
            </form>
          </AccountPanel>
        </Box>
      </MainContent>
    </>
  );
}
